export default __webpack_public_path__ + "static/media/catworx.24a68c7c.png";